import React from 'react';
import './InfinityMark.css';

// Brand mark: two photo frames turned into diamonds that meet at a gold point.
// tone   — colour set for the background it sits on (dark | light | white | gold)
// motion — 'static', 'intro' (frames swing in once) or 'loop' (endless loader)
const TONES = {
  dark: { left: '#D4AF37', right: '#F4F1EA', dot: '#F4CF67' },
  light: { left: '#B8932A', right: '#0A0A0A', dot: '#B8932A' },
  white: { left: '#FFFFFF', right: '#FFFFFF', dot: '#FFFFFF' },
  gold: { left: '#D4AF37', right: '#D4AF37', dot: '#D4AF37' },
};

// Each frame is a square centred on its diamond, rotated 45° at rest, so the
// animations can start from an upright "photo frame" and swing into place.
const SIDE = 35.36;

function InfinityMark({ tone = 'dark', motion = 'static', size = 120, className = '', title = 'Infinity Creative Agency' }) {
  const c = TONES[tone] || TONES.dark;
  return (
    <svg
      viewBox="-3 -3 106 56"
      width={size}
      height={(size * 56) / 106}
      className={`ica-mark ica-mark--${motion} ${className}`}
      role="img"
      aria-label={title}
    >
      <rect className="ica-mark__left" x={25 - SIDE / 2} y={25 - SIDE / 2} width={SIDE} height={SIDE} fill="none" stroke={c.left} strokeWidth="4" />
      <rect className="ica-mark__right" x={75 - SIDE / 2} y={25 - SIDE / 2} width={SIDE} height={SIDE} fill="none" stroke={c.right} strokeWidth="4" />
      <circle className="ica-mark__dot" cx="50" cy="25" r="5" fill={c.dot} />
    </svg>
  );
}

export default InfinityMark;
